module.exports = __webpack_public_path__ + "img/placeholder.31a6958b.svg";